import React, { useRef, useState } from "react";
// Import Swiper React components
import { Swiper, SwiperSlide } from "swiper/react";

// Import Swiper styles
import "swiper/swiper.min.css";
import "swiper/components/pagination/pagination.min.css";
import "swiper/components/navigation/navigation.min.css";
import { ChevronRight, ChevronLeft } from "react-feather";
// import Swiper core and required modules
import SwiperCore, { Pagination, Navigation } from "swiper/core";
import bookmark from "../img/bookmark.svg";
import TrendingJobs3 from "../img/trending3.png";
import TrendingJobs2 from "../img/trending2.png";
import TrendingJobs4 from "../img/trending4.png";
import TrendingJobs1 from "../img/trending1.png";
// install Swiper modules
import pin from "../img/pin.svg";
SwiperCore.use([Pagination, Navigation]);

export default function App() {
  return (
    <>
      <div className="flex justify-between items-center mt-16 mb-8">
        <h2 className="fsize28 font-bold">TRENDING JOBS</h2>
        <div className="flex ">
          <ChevronLeft
            width="30px"
            height="30px"
            className="trend-left-i mr-2 disabled"
          />
          <ChevronRight width="30px" height="30px" className="trend-right-i" />
        </div>
      </div>
      <Swiper
        slidesPerView={4}
        spaceBetween={30}
        slidesPerGroup={4}
        loop={true}
        loopFillGroupWithBlank={true}
        pagination={{
          clickable: true,
        }}
        navigation={false}
        className="mySwiper swiperpagination-dot"
      >
        <SwiperSlide className="shadow-lg rounded-12px mb-4 showcard">
          <div className="img__wrap w-full">
            <div>
              <div className="relative">
                <img
                  src={TrendingJobs1}
                  className="w-full rounded-t-12px cust-h210px object-fill"
                  alt="banner-img "
                />
                <div className="absolute bookmark-parent text-white rounded-full">
                  <img
                    src={bookmark}
                    alt="trendingjobs"
                    className="bookmark-t-c"
                  />
                </div>
              </div>
              <div className="p-4">
                <p className="text-black line-clamp-2 font-medium fsize18 ">
                  Phone Banking Officer
                </p>
              </div>
            </div>
            <div className="img__description_layer">
              <h1 className="img__description trend-hover-h">
                Commercial Banking
              </h1>

              <p className="font-bold p-4 fsize18 color-4b4b4b">
                Phone Banking Officer
              </p>
              <p className="text-muted-1 ">
                Required Experience:{" "}
                <span className="text-black ">1-3 years</span>
              </p>
              <p className="text-muted-1 ">
                Education: <span className="text-black ">CA</span>
              </p>
              <div className="flex justify-around mt-4">
                <div className="flex items-center">
                  <img src={pin} alt="pinlogo" className="pn-icon-w" />

                  <p className="text-muted-1 ml-2">Mumbai</p>
                </div>

                <p className="text-muted-1 ">3d ago</p>
              </div>

              <div className="flex justify-center">
                <button className="cust-trendapply-btn flex">APPLY NOW</button>
              </div>
            </div>
          </div>
        </SwiperSlide>

        <SwiperSlide className="shadow-lg rounded-12px mb-4 showcard">
          <div className="img__wrap w-full">
            <div>
              <div className="relative">
                <img
                  src={TrendingJobs2}
                  className="w-full rounded-t-12px cust-h210px object-fill"
                  alt="banner-img "
                />
                <div className="absolute bookmark-parent text-white rounded-full">
                  <img src={bookmark} alt="bookmark" className="bookmark-t-c" />
                </div>
              </div>

              <div className="p-4">
                <p className="text-black font-medium line-clamp-2 fsize18">
                  Senior Bank Manager
                </p>
              </div>
            </div>
            <div className="img__description_layer">
              <h1 className="img__description trend-hover-h">
                Commercial Banking
              </h1>

              <p className="font-bold p-4 fsize18 color-4b4b4b">
                Senior Bank Manager
              </p>
              <p className="text-muted-1 ">
                Required Experience:{" "}
                <span className="text-black ">1-3 years</span>
              </p>
              <p className="text-muted-1 ">
                Education: <span className="text-black ">CA</span>
              </p>
              <div className="flex justify-around mt-4">
                <div className="flex items-center">
                  <img src={pin} className="pn-icon-w" />

                  <p className="text-muted-1 ml-2">Mumbai</p>
                </div>

                <p className="text-muted-1 ">3d ago</p>
              </div>

              <div className="flex justify-center">
                <button className="cust-trendapply-btn flex">APPLY NOW</button>
              </div>
            </div>
          </div>
        </SwiperSlide>

        <SwiperSlide className="shadow-lg rounded-12px mb-4 showcard">
          <div className="img__wrap w-full">
            <div>
              <div className="relative">
                <img
                  src={TrendingJobs3}
                  className="w-full rounded-t-12px cust-h210px object-fill"
                  alt="banner-img "
                />
                <div className="absolute bookmark-parent text-white rounded-full">
                  <img src={bookmark} alt="bookmark" className="bookmark-t-c" />
                </div>
              </div>
              <div className="p-4">
                <p className="text-black font-medium line-clamp-2 fsize18">
                  Phone Banking Officer
                </p>
              </div>
            </div>
            <div className="img__description_layer">
              <h1 className="img__description trend-hover-h">
                Commercial Banking
              </h1>

              <p className="font-bold p-4 fsize18 color-4b4b4b">
                Phone Banking Officer
              </p>
              <p className="text-muted-1 ">
                Required Experience:{" "}
                <span className="text-black ">1-3 years</span>
              </p>
              <p className="text-muted-1 ">
                Education: <span className="text-black ">CA</span>
              </p>
              <div className="flex justify-around mt-4">
                <div className="flex items-center">
                  <img src={pin} className="pn-icon-w" />

                  <p className="text-muted-1 ml-2">Mumbai</p>
                </div>

                <p className="text-muted-1 ">3d ago</p>
              </div>

              <div className="flex justify-center">
                <button className="cust-trendapply-btn flex">APPLY NOW</button>
              </div>
            </div>
          </div>
        </SwiperSlide>

        <SwiperSlide className="shadow-lg rounded-12px mb-4 showcard">
          <div className="img__wrap w-full">
            <div>
              <div className="relative">
                <img
                  src={TrendingJobs4}
                  className="w-full rounded-t-12px cust-h210px object-fill"
                  alt="banner-img "
                />
                <div className="absolute bookmark-parent text-white rounded-full">
                  <img src={bookmark} alt="bookmark" className="bookmark-t-c" />
                </div>
              </div>
              <div className="p-4">
                <p className="text-black font-medium line-clamp-2 fsize18 p-4">
                  Senior Bank Manager
                </p>
              </div>
            </div>
            <div className="img__description_layer">
              <h1 className="img__description trend-hover-h">
                Commercial Banking
              </h1>

              <p className="font-bold p-4 fsize18 color-4b4b4b">
                Senior Bank Manager
              </p>
              <p className="text-muted-1 ">
                Required Experience:{" "}
                <span className="text-black ">1-3 years</span>
              </p>
              <p className="text-muted-1 ">
                Education: <span className="text-black ">CA</span>
              </p>
              <div className="flex justify-around mt-4">
                <div className="flex items-center">
                  <img src={pin} className="pn-icon-w" />

                  <p className="text-muted-1 ml-2">Mumbai</p>
                </div>

                <p className="text-muted-1 ">3d ago</p>
              </div>

              <div className="flex justify-center">
                <button className="cust-trendapply-btn flex">APPLY NOW</button>
              </div>
            </div>
          </div>
        </SwiperSlide>
      </Swiper>
    </>
  );
}
